import loader from '../moduleLoader.js';
import autoComplete from 'javascript-autocomplete';

function SearchAutocomplete(form) {
    let searchInput;
    let suggestionClassName = " hasSuggestion";

    function init() {
        var searchInputId = form.getAttribute('data-autocomplete-for');
        searchInput = document.getElementById(form.getAttribute('data-autocomplete-for'));
        searchInput.addEventListener('blur', onClose);
        searchInput.addEventListener('keyup', checkKeyInput);
        var offsetTop = -52; // Change this for mobile
        new autoComplete({
            selector: '#' + searchInputId,
            minChars: 2,
            source: function (term, response) {
                getSuggestions(term, function (data) { response(data); });
            },
            onSelect: function (e) {
                form.submit();
                onClose();
            },
            delay: 300,
            offsetTop: offsetTop,
            cache: false
        });
    }

    function onOpen() {
        if (searchInput.className.includes(suggestionClassName))
            return;
        searchInput.className += suggestionClassName;
    }

    function onClose() {
        searchInput.className = searchInput.className.replace(suggestionClassName, '');
    }

    function checkKeyInput(e) {
        var length = e.target.value.length;
        if (e.keyCode === 13) {
            form.submit();
        }
        if (length < 2) {
            onClose();
        }
    }

    function getSuggestions(term, callback) {
        window.searchSuggestionXHR = new XMLHttpRequest();
        fetchSuggestions(term.trim(), function (responseText) {
            return showSuggestions(responseText, callback);
        });
    }

    function fetchSuggestions(term, callback) {
        const url = "/find/rest/autocomplete/get/" + term + "?size=3";

        window.searchSuggestionXHR.abort();
        searchSuggestionXHR.onreadystatechange = function () {
            if (this.readyState !== 4) return;
            if (this.status !== 200) {
                console.log('Error fetching suggestions');
                return;
            }
            callback(this.responseText);
        };

        searchSuggestionXHR.open('GET', url, true);
        searchSuggestionXHR.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        searchSuggestionXHR.send();
    }

    function showSuggestions(responseText, callback) {
        var response = JSON.parse(responseText);

        var matches = [];

        response.Hits.forEach(function (item) {
            matches.push(item.Query);
        });

        if (matches.length > 0) {
            onOpen();
        } else {
            onClose();
        }

        callback(matches);
    }

    return {
        init: init
    }
}

loader.add('SearchAutocomplete', SearchAutocomplete);

export default SearchAutocomplete;